import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llegué a mi entrevista sintiéndome diferente. Sabía las respuestas y las pude decir en inglés sin quedarme en blanco. Pasé a la primera.',
    author: 'Rosa M.',
    location: 'Miami Florida'
  }, {
    quote: 'Lo que más me ayudó fue el audio. Practicaba mientras manejaba al trabajo y cuando llegó el día ya sentía que había hecho esa entrevista cien veces.',
    author: 'José L.',
    location: 'Houston Texas'
  }, {
    quote: 'Pensé que no iba a poder porque mi inglés no es perfecto. Pero con la traducción en español entendí todo y supe exactamente qué decir.',
    author: 'Carmen R.',
    location: 'Los Angeles California'
  }];
  return <section className="w-full bg-white" data-id="element-271">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-24" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-273">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-12 text-center" data-id="element-274">
            Lo Que Dicen Quienes Ya Lo Usaron
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-275">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-[#F7F5F0] p-8 rounded-2xl relative" data-id="element-276">
                <QuoteIcon className="w-10 h-10 text-[#C9A84C] opacity-30 absolute top-6 left-6" data-id="element-277" />
                <div className="flex gap-1 mb-6 mt-4 justify-end" data-id="element-278">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#C9A84C] fill-current" data-id="element-279" />)}
                </div>
                <p className="text-gray-700 text-lg italic mb-6 relative z-10" data-id="element-280">
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-gray-200 pt-4" data-id="element-281">
                  <p className="font-bold text-[#1B2A4A]" data-id="element-282">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-283">
                    {testimonial.location}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}